import { Div, DivProps, LabelProps, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React from 'react';
import { FormPropsWithValue } from '../HOCs';
import { TileCheckboxButton } from './TileCheckboxButton';

export interface TileCheckboxGroupItem {
  text: string;
  value: any;
  hideCheckbox?: boolean;
  checked?: boolean;
  subText?: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface TileCheckboxGroupProps extends FormPropsWithValue {
  options: TileCheckboxGroupItem[];
  direction: 'horizontal' | 'vertical';
  buttonMaxWidth?: string;
  style?: any;
  divProps?: DivProps;
  labelProps?: LabelProps;
}

export const TileCheckboxGroupOG: React.VFC<TileCheckboxGroupProps> = ({
  options,
  direction = 'vertical',
  buttonMaxWidth,
  style,
  divProps,
  labelProps,
  name,
  ...input
}) => {
  const isVertical = direction === 'vertical';
  const items = options?.map(
    ({ text, value, hideCheckbox, checked, subText, onChange }) => {
      return {
        label: <P variant="bodyImportant">{text}</P>,
        checkbox: value,
        hideCheckbox,
        checked,
        subText: subText ? (
          <P variant="bodyImportant" alignSelf="center" color="#007BFF">
            {subText}
          </P>
        ) : null,
        onChange,
      };
    },
  );

  return (
    <Div display="flex" flexDirection="column" gridGap={2}>
      <Div display="flex" flexDirection="column" gridGap={[3, null, 4]}>
        {input._error && (
          <Div
            textAlign={['left', null, 'center']}
            display="flex"
            gridGap={2}
            alignItems="center"
            justifyContent={['flex-start', null, 'center']}
          >
            <IconV2 name="alert" width={20} height={20} fill="error" />
            <P
              id="mainCoverageSectionErrorMessage"
              variant="footnoteError"
              data-testid="MainCoverageSection.error.text"
            >
              {input._error}
            </P>
          </Div>
        )}
        <Div
          display={'flex'}
          flexDirection={isVertical ? 'row' : 'column'}
          gridGap={[2, 2, 2]}
          width={'100%'}
          {...divProps}
        >
          {items.map((item, idx) => {
            return (
              <>
                <TileCheckboxButton
                  key={idx}
                  style={style}
                  buttonMaxWidth={buttonMaxWidth}
                  labelProps={item.hideCheckbox ? {} : labelProps}
                  fieldName={name}
                  {...item}
                  checkbox={
                    item.checkbox
                      ? {
                          name: item.checkbox,
                          value: item.checkbox,
                          checked: item?.checked || false,
                          onChange: item?.onChange,
                        }
                      : undefined
                  }
                />
                {item?.subText}
              </>
            );
          })}
        </Div>
      </Div>
    </Div>
  );
};
